import axios from 'axios';

// Configuración de las URLs de la API
const API_URLS = {
    production: {
        http: 'https://centro-infantil-mijardin.onrender.com/api/chatbot',
        ws: 'wss://centro-infantil-mijardin.onrender.com',
        ia: 'https://apli271487171sistema-production.up.railway.app'
    },
    development: {
        http: 'http://localhost:5000/api/chatbot',
        ws: 'ws://localhost:5000',
        ia: 'http://localhost:5000'
    }
};

// Determinar las URLs base según el entorno
const API_URL = process.env.NODE_ENV === 'production' ? API_URLS.production.http : API_URLS.development.http;
const IA_MODEL_URL = process.env.NODE_ENV === 'production' ? API_URLS.production.ia : API_URLS.development.ia;

// Configuración global de axios
axios.defaults.withCredentials = true;

export const consultarActividades = async (id_child) => {
    try {
        const response = await axios.get(
            `${API_URL}/actividades/${id_child}`,
            {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            }
        );
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || 'Error al obtener actividades');
    }
};

export const consultarEvaluaciones = async (id_child) => {
    try {
        const response = await axios.get(
            `${API_URL}/evaluaciones/${id_child}`,
            {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            }
        );
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || 'Error al obtener evaluaciones');
    }
};

export const consultarModeloIA = async (pregunta) => {
    try {
        const response = await axios.post(`${IA_MODEL_URL}/chat`, {
            mensaje: pregunta
        }, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            withCredentials: true
        });
        
        if (!response.data || !response.data.respuesta) {
            throw new Error('La respuesta del modelo no contiene datos válidos');
        }
        
        return {
            success: true,
            data: {
                respuesta: response.data.respuesta
            }
        };
    } catch (error) {
        return {
            success: false,
            error: error.response?.data?.error || 'Error al consultar el modelo de IA',
            data: null
        };
    }
};

export const registrarConsulta = async (pregunta, respuesta, id_centro, rol ,incidencia) => {
    try {
        const response = await axios.post(
            `${API_URL}/registrar-consulta`,
            {
                pregunta,
                respuesta,
                id_centro,
                rol,
                incidencia
            },
            {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            }
        );
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || 'Error al registrar la consulta');
    }
};

export const editarConsulta = async (id, pregunta, respuesta, id_centro,rol,incidencia) => {
    try {
        const response = await axios.put(
            `${API_URL}/editar-consulta/${id}`,
            {
                pregunta,
                respuesta,
                id_centro,
                rol,
                incidencia 
            },
            {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            }
        );

        if (!response.data.success) {
            throw new Error(response.data.message || 'Error al editar la consulta');
        }

        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || 'Error al editar la consulta');
    }
};

export const eliminarConsulta = async (id) => {
    try {
        const response = await axios.delete(
            `${API_URL}/eliminar-consulta/${id}`,
            {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            }
        );

        if (!response.data.success) {
            throw new Error(response.data.message || 'Error al eliminar la consulta');
        }

        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || 'Error al eliminar la consulta');
    }
};

export const obtenerConsultas = async () => {
    try {
        const response = await axios.get(
            `${API_URL}/consultas`,
            {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            }
        );
        
        if (!response.data || !response.data.data) {
            throw new Error('Formato de respuesta inválido');
        }
        
        return {
            success: response.data.success,
            message: response.data.message,
            data: response.data.data
        };
    } catch (error) {
        throw new Error(error.response?.data?.message || 'Error al obtener las consultas');
    }
};

export const buscarRespuestaPorPregunta = async (pregunta) => {
    try {
        const response = await axios.post(
            `${API_URL}/buscar-respuesta`,
            { pregunta },
            {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            }
        );

        if (!response.data || !response.data.data) {
            throw new Error('Formato de respuesta inválido');
        }

        return {
            success: response.data.success,
            message: response.data.message,
            data: response.data.data
        };
    } catch (error) {
        throw new Error(error.response?.data?.message || 'Error al buscar la respuesta');
    }
};

export const registrarSugerencia = async (contenido) => {
    try {
        const user = JSON.parse(localStorage.getItem('user'));
        
        if (!user || !user.id) {
            throw new Error('Usuario no autenticado');
        }

        const response = await axios.post(
            `${API_URL}/sugerencias`,
            {
                contenido: contenido,
                id_usuario: user.id
            },
            {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                    'Content-Type': 'application/json'
                }
            }
        );

        if (!response.data.success) {
            throw new Error(response.data.message || 'Error al registrar la sugerencia');
        }

        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || 'Error al registrar la sugerencia');
    }
};

export const obtenerSugerencias = async () => {
    try {
        const response = await axios.get(`${API_URL}/sugerencias`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const actualizarEstadoSugerencia = async (id, estado) => {
    try {
        const response = await axios.put(
            `${API_URL}/sugerencias/${id}`,
            { estado },
            {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            }
        );
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || 'Error al actualizar el estado de la sugerencia');
    }
};

export const eliminarSugerencia = async (id) => {
    try {
        const response = await axios.delete(
            `${API_URL}/sugerencias/${id}`,
            {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            }
        );
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || 'Error al eliminar la sugerencia');
    }
};
